import React, { forwardRef, useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

import "./style.scss";
import { useGetStoresQuery } from "../../../api/stores";
import { autocomplete } from "../orderHelper/styles";
import { Box } from "@mui/system";
import { sortArrOfData } from "../../../constants/sorting";
import { useSelector } from "react-redux";

const HubSelect = forwardRef(({ isError, isLoading, sx, ...props }, ref) => {
  const { data: stores, isFetching: storesLoadingStatus } = useGetStoresQuery(
    null,
    { refetchOnMountOrArgChange: false }
  );
  const currentUser = useSelector((state) => state.auth.currentUser);

  const [hubList, setHubList] = useState([]);

  useEffect(() => {
    if (currentUser?.role === "metro_manager") {
      let metro_manager_metros = JSON.parse(localStorage.getItem("user_metro"));
      const hubs =
        currentUser &&
        stores?.filter((store) => {
          return metro_manager_metros?.find((metros) => {
            return store.metro === metros;
          });
        });
      hubs && setHubList([{ name: "", id: "" }, ...hubs]);
    } else {
      if (!stores) return;
      const hubs = sortArrOfData(stores, "name");
      hubs && setHubList([{ name: "", id: "" }, ...hubs]);
    }
  }, [stores, storesLoadingStatus, currentUser]);

  return (
    <Autocomplete
      disabled={isLoading}
      noOptionsText={"Select Hub"}
      options={hubList}
      value={stores?.name}
      getOptionLabel={(option) => option?.name}
      sx={sx ||
      {
        width: 300,
        ...autocomplete,
      }}
      blurOnSelect={true}
      ref={ref}
      {...props}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select Hub"
          inputProps={{
            ...params.inputProps,
          }}
          required={false}
        />
      )}
    />
  );
});

export default HubSelect;
